import React from 'react';
import styled from 'styled-components';

const IconWrapper = styled.svg`
  width: ${props => (props.width ? `${props.width}px` : '100px')};
  height: 100px;
  background-color: ${props => props.bgColor || props.theme.colors.transparent};

  use {
    fill: ${props => props.fillColor};
  }
`;

function Icon({ id, fillColor, bgColor, width, ...rest }) {
  const svgPath = `/assets/images/sprites.svg#${id}`;
  return (
    <IconWrapper
      fillColor={fillColor}
      bgColor={bgColor}
      width={width}
      {...rest}
    >
      <use xlinkHref={svgPath} />
    </IconWrapper>
  );
}

export default Icon;
